// extracted by mini-css-extract-plugin
export default {"monoPaymentButton":"OrderPage_monoPaymentButton__tdFQY"};